import {
  IHttpResponse,
  ILocationService,
  IWindowService,
  IQService,
} from "angular";
import { UserProfile } from "../UserProfile";

export const vsName = "httpUnauthenticatedInterceptorService";

export class HttpUnauthenticatedInterceptorService {
  static $inject = ["$window", "$location", "$q", "userProfile"];

  openLoginInNewWindow: boolean = false;

  constructor(
    private readonly $window: IWindowService,
    private readonly $location: ILocationService,
    private readonly $q: IQService,
    userProfile: UserProfile,
  ) {
    this.openLoginInNewWindow = userProfile.isAuthenticated();
  }

  responseError(httpResponse: IHttpResponse<any>) {
    if (!this.isAuthenticationError(httpResponse)) {
      return httpResponse;
    }

    this.openLoginInNewWindow
      ? this.$window.open("/login?closeAfterLogin=true", "slottrakLogin")
      : this.$location.path("/login");

    return this.$q.reject(httpResponse);
  }

  private isAuthenticationError(rejection: IHttpResponse<any> | undefined) {
    return rejection?.status === 401;
  }
}
